// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import QrcodeSvg from '@rsuite/icon-font/lib/application/Qrcode';
var Qrcode = createSvgIcon({
  as: QrcodeSvg,
  ariaLabel: 'qrcode',
  category: 'application',
  displayName: 'Qrcode'
});
export default Qrcode;